/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ImageComparison from 'DesignSystem/ImageComparison/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Compare/Content"
  
}) {
let patientImageImageseriesIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'imageseries.id',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let onClose = fromHelpers.useOnClose({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ImageComparison
  viewPath={`${viewPath}/ImageComparison`}
 data="patient_image.imageseries.id"
 imageSeriesId={patientImageImageseriesIdValueData}
 data="patient_image.id"
 imageId={patientImageIdValueData}
 onClose={onClose}
/>
{children}
</React.Fragment>)
}